<template>
  <div class="lg:mt-28"></div>
  <SectionTitle name="NEW ALBUM OUT !" />
  <Highlight :highlight="highlight" />
  <SectionTitle name="ALL RELEASES" />
  <SubTitle name="ALBUMS" />
  <AlbumList />
  <SubTitle name="SINGLES & EPS" />
  <SingleList />
  <SubTitle name="RUN! RUN! JUMP! PUNCH!" />
  <p class="lg:text-justify lg:ml-16 text-lg">
    <strong class="text-green-400">Run! Run! Jump! Punch!</strong> is a Chiptune / Punk rock band from Lille, France in which I play Synth, 
    and drum-programming.
  </p>
  <div class="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 lg:mx-8">
    <Album v-for="album in albums" :key="album.name" :albumData="album" :isRRJP="true"/>
  </div>
</template>
<script>
import SectionTitle from '../common/SectionTitle'
import Highlight from '../common/Highlight'
import SubTitle from '../common/SubTitle'
import AlbumList from './AlbumList'
import SingleList from './SingleList'
import Album from './Album'
import axios from 'axios'

export default {
  components: { SubTitle, AlbumList, SingleList, SectionTitle, Highlight, Album },
  name: 'Music',
  data: function () {
    return { highlight: {}, albums: [], loaded: true }
  },
  mounted: function() {
    axios
      .get('/files/highlight.json')
      .then(response => { 
        this.highlight = response.data;
    })

    axios
      .get('/files/rrjp-albums.json')
      .then(response => { 
        this.albums = response.data.sort((a, b) => { return a.releaseDate > b.releaseDate ? -1 : 1});
        this.loaded = true
        for (var i = 0; i < this.albums.length; i++) {
          this.albums[i].id = i
        }
      })
  }
}
</script>